<template>
  <div>
    <template v-if="aType === 'select'">
      <div style="margin-top: 15px">
        <el-input
          v-model="params.chat_name"
          placeholder="请输入群名称"
          size="small"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchList"
          />
        </el-input>
      </div>
      <div class="select-wrap">
        <div>全部群聊（{{ total_count }}）：</div>
        <el-checkbox
          v-model="checkStatus"
          @change="selectChatAll"
        >
          全选
        </el-checkbox>
      </div>
    </template>
    <div class="edit-sop">
      <ul
        v-if="list"
        class="guize-list"
      >
        <li
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="avatar-box">
            <img
              :src="require('@/assets/img/sopavatar.png')"
              width="40px"
            >
          </div>
          <div class="item">
            <h4 class="title">
              {{ item.name }}
            </h4>
            <p class="content">
              群主：<span class="name">{{ item.owner }}</span>
              <span v-if="item.bind_time">绑定时间 {{ item.bind_time }}</span>
            </p>
          </div>
          <div class="btn-box">
            <template v-if="aType === 'select'">
              <el-checkbox
                v-model="item.checked"
                @change="(val) => selectChat(val, item)"
              />
            </template>
            <template v-else-if="aType === 'update'">
              <el-button
                type="primary"
                size="small"
                @click="deleteRules(item.chat_id)"
              >
                移除规则
              </el-button>
            </template>

            <!--  -->
          </div>
        </li>
      </ul>
      <template v-else>
        <div class="nodata">
          暂无群聊
        </div>
      </template>
    </div>
    <div
      v-if="aType === 'select'"
      slot="footer"
      class="select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.pageSize"
          @current-change="handleCurrentChange"
        />
      </div>
      <div style="text-align: right">
        <el-button
          type="primary"
          @click="bindChat"
        >
          确认
        </el-button>
        <el-button @click="cancelBind">
          取消
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sopBindChat, getSopDetail } from '@/api/membership/membershipsop'
import { getMemberShipList } from '@/api/membership/membershipList'
export default {
  props: {
    data: Array,
    aType: String
  },
  data () {
    return {
      key: 1,
      total_count: 0,
      loading: false,
      params: {
        chat_name: '',
        page: 1,
        page_size: 20
      },
      list: [],
      selectChatIds: [],
      submitLoading: false,
      checkStatus: false
    }
  },
  computed: {
    id () {
      return this.data[0].id
    }
    // title() {
    //   return  this.title
    // }
  },
  watch: {
    info: {
      immediate: true,
      handler (val) {
        console.log('val--->', val)
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    //获取社群列表
    getList () {
      this.loading = true
      getSopDetail(this.id).then((res) => {
        if (res) {
          this.list = res.chat_list
          this.selectChatIds = res.bind_chat.split(',')
          if (this.aType === 'select') {
            getMemberShipList(this.params).then((res) => {
              if (res) {
                res.list.map((item) => {
                  this.selectChatIds.map((id) => {
                    if (id === item.chat_id) {
                      item.checked = true
                      return item
                    }
                  })
                })
                this.list = res.list
                this.total_count = res.total_count
                this.loading = false
              }
            })
          }
        }
      })
    },
    // 查询列表数据
    searchList () {
      this.params.page = 1
      this.getList()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },
    selectChat (val, key) {
      if (val) {
        this.selectChatIds.push(key.chat_id)
        if (this.selectChatIds.length === this.total_count) {
          this.checkStatus = true
        }
      } else {
        this.selectChatIds.splice(
          this.selectChatIds.findIndex((item) => item.chat_id === key.chat_id),
          1
        )
        this.checkStatus = false
      }
    },
    bindChat () {
      //绑定群聊
      if (this.selectChatIds.length != 0) {
        try {
          const url = process.env.VUE_APP_BASE_API + `/salesperson/sop/bind-chat/${this.id}`
          this.$http.post(url, { bind_chat: this.selectChatIds })
          this.$message.success('操作成功')
          this.$emit('close')
          this.$emit('finder-refresh')
        } catch (e) {
          this.$message.success('操作失败')
        }
      } else {
        return this.$message.error('请选择群聊')
      }
    },
    selectChatAll (val) {
      //全选群聊
      if (val) {
        this.list.map((item) => {
          item.checked = true
          this.selectChatIds.push(item.chat_id)
          return item
        })
      } else {
        this.list.map((item) => {
          item.checked = false
          return item
        })
        this.selectChatIds = []
      }
    },
    deleteRules (chat_id) {
      //移除群聊
      this.selectChatIds.splice(
        this.selectChatIds.findIndex((item) => item === chat_id),
        1
      )
      try {
        const url = process.env.VUE_APP_BASE_API + `/salesperson/sop/bind-chat/${this.id}`
        this.$http.post(url, { bind_chat: this.selectChatIds })
        this.$message.success('操作成功')
        this.$emit('close')
        this.$emit('finder-refresh')
      } catch (e) {
        this.$message.success('操作失败')
      }
    },
    cancelBind () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
}
.select-footer {
  padding: 20px 0;
}
.nodata {
  padding: 30px;
  text-align: center;
  color: #666666;
}
.guize-list {
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f1f1f1;
    padding: 5px 0;
    .avatar-box {
      width: 50px;
    }
    .btn-box {
      width: 86px;
      text-align: center;
    }
    .item {
      flex: 1;
      font-size: 12px;
      .title {
        color: #333;
      }
      .content {
        color: #666666;
        .name {
          color: #333;
          display: inline-block;
          padding: 10px;
        }
      }
    }
  }
}
</style>
